import React from 'react';

const Florida = () => {
  return (
    <div>
      
    </div>
  );
}

export default Florida;
